import React, { useState, useEffect } from 'react';

const PAGES = 5;

const PageNavigation = props => {
    const { postType='', totalCount, showCount = 5, onChange = () => {} } = props;
    const [currentPage, setCurrentPage] = useState(1);
    
    const totalPages = Math.ceil(totalCount / showCount);

    const handleFirstPage = () => setCurrentPage(1);
    const handleLastPage = () => setCurrentPage(totalPages);
    const handlePrevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));

    const getPageNumbers = () => {
        const pages = [];
        const startPage = Math.max(currentPage - 2, 1);
        const endPage = Math.min(startPage + PAGES - 1, totalPages);
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        return pages;
    };

    useEffect(() => {
        onChange(currentPage);
    }, [currentPage, postType]);

    if (totalPages === 1) return '';

    return (
        <ul className="pagination">
            {totalPages > 5 && <>
                <li>
                    <a onClick={handleFirstPage} disabled={currentPage === 1}>
                        <i className="icon icon-arrow-left2"></i>
                    </a>
                </li>
                <li>
                    <a onClick={handlePrevPage} disabled={currentPage === 1}>
                        <i className="icon icon-arrow-left"></i>
                    </a>
                </li>
            </>}   
            {getPageNumbers().map(page => (
                <li
                    key={page}
                    className={`pagination-index ${page === currentPage ? 'active' : ''}`}
                    onClick={() => setCurrentPage(page)}
                ><a>{page}</a>
                </li>
            ))}
            {totalPages > 5 && <>
                <li>
                    <a onClick={handleNextPage} disabled={currentPage === totalPages}>
                        <i className="icon icon-arrow-right"></i>
                    </a>
                </li>
                <li>
                    <a onClick={handleLastPage} disabled={currentPage === totalPages}>
                        <i className="icon icon-arrow-right2"></i>
                    </a>
                </li>
            </>}
        </ul>            
    );
};

export default PageNavigation;

